import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '@env/environment';

export interface Beuser {
  id: number;
  name: string;
  login: string;
  email: string;
  beusergroup_id: number;
  role_id: number;
  role_name: string;
  admin: number;
  su: number;
  f_id: number;
  dienstnehmer_name?: string | null;
  active: number;
  isapproved: number;
  isactivated: number;
  lastlogin?: string | null;
  lastip?: string | null;
  pwd?: string;
}

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class BeuserService {
  errorMsg = '';

  constructor(private httpClient: HttpClient) {}

  getAll(): Observable<Beuser[]> {
    return this.httpClient.get<any>(`${environment.serverUrl}/beuser`, httpOptions).pipe(
      map((response) => (response?.data || []) as Beuser[]),
      catchError((error) => this.handleError(error))
    );
  }

  save(user: Beuser): Observable<any> {
    const url =
      user.id && user.id > 0
        ? `${environment.serverUrl}/beuser/${user.id}`
        : `${environment.serverUrl}/beuser`;

    return this.httpClient.post<any>(url, JSON.stringify(user), httpOptions).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  deactivate(id: number): Observable<any> {
    return this.httpClient.delete<any>(`${environment.serverUrl}/beuser/${id}/0/0`, httpOptions).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      this.errorMsg = `Error: ${error.error.message}`;
    } else {
      this.errorMsg = `Server error: ${error.status}`;
    }
    return throwError(this.errorMsg);
  }
}
